import styled from 'styled-components';
import { themeGet } from '../theme/themeGet/get.js';

var StyledSvg = styled.svg.withConfig({
  displayName: "StyledSvg",
  componentId: "sc-2771a4-0"
})(["fill:", ";"], function (_ref) {
  var _ref$$inverted = _ref.$inverted,
    $inverted = _ref$$inverted === void 0 ? false : _ref$$inverted;
  return $inverted ? themeGet('colors.gray.0') : themeGet('colors.gray.1000');
});

export { StyledSvg };
